import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  // console.log(
  //   "🛡️ [DEBUG] ProtectedRoute - isLoading:",
  //   isLoading,
  //   "isAuthenticated:",
  //   isAuthenticated
  // );

  // אם עדיין בוודק authentication, הצג loading
  if (isLoading) {
    // console.log("🛡️ [DEBUG] ProtectedRoute - Still loading, showing spinner");
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-600">בודק הרשאות...</p>
        </div>
      </div>
    );
  }

  // אם לא מחובר, הפנה לדף כניסה הנכון
  if (!isAuthenticated) {
    // console.log(
    //   "🛡️ [DEBUG] ProtectedRoute - Not authenticated, redirecting to login"
    // );
    return <Navigate to="/backoffice/login" replace />;
  }

  // אם מחובר, הצג את התוכן
  // console.log(
  //   "🛡️ [DEBUG] ProtectedRoute - Authenticated, showing protected content"
  // );
  return <>{children}</>;
};
